module.exports = __webpack_public_path__ + "static/media/team2.a9c63545.png";